import { render, staticRenderFns } from "./TeachingHistoryDialog.vue?vue&type=template&id=799c1daa&scoped=true&"
import script from "./TeachingHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./TeachingHistoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./TeachingHistoryDialog.vue?vue&type=style&index=0&id=799c1daa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799c1daa",
  null
  
)

export default component.exports